
import { defineComponent } from 'vue'

import ActiveUserMixin from '~/mixins/activeUserMixin'
import WebhookMixin from '~/mixins/webhookMixin'

export default defineComponent({
  name: 'TestWebhookEndpoint',
  mixins: [WebhookMixin, ActiveUserMixin],
  data() {
    return {
      testing: false,
      showTestModal: false
    }
  },
  computed: {
    testPayload(): string {
      return `{
  "id": "370440586387259393",
  "type": "test.event",
  "created": "${new Date().toISOString()}",
  "version": "v1.0.0",
  "data": {
    "Test": true
  }
}`
    }
  },
  methods: {
    toggleModal(): void {
      this.showTestModal = !this.showTestModal
    },
    async sendTestPayload(close: () => void): Promise<void> {
      const { webhookId } = this.$route.params
      this.testing = true
      try {
        const response = await this.testEndpoint({ webhookId })
        if (response.ok) {
          this.$toast.success('Sent the test payload successfully.')
          close()
        }
      } catch (e) {
        this.$toast.danger((e as Error).message.replace('GraphQL error: ', ''))
      } finally {
        this.testing = false
      }
    },
    close(): void {
      this.showTestModal = false
    }
  }
})
